<template>
    <div class="sfbz">
        <div class="searchall">
            <div class="search" style="margin-top:10px">
                <span>公示名称：</span>
                <input type="text" v-model="ss" style="width:70%" placeholder="请输入公示名称">
            </div>
            
            <div class="search datesearch" style="margin-top:10px">
                <span>收入所属时间：</span>
                <input type="date" v-model="starttime">
                -
                <input type="date" v-model="endtime">
            </div>
            <div class="btns">
                <button class="searchbt" @click="chongzhi">重置</button>
                <button class="searchbt" style="margin-left:20px" @click="search">搜索</button>
            </div>
            
        </div>
        
        <div class="sfbzcontent">
            <div class="bz">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="fyitem" v-for="(item, fyindex) in list" :key="fyindex">
                    <van-swipe  class="lb" >
                        <van-swipe-item v-for="(i,idx) in list[fyindex].attachs" :key="idx"><img :src="'https://zhwy.zjj.suqian.gov.cn'+i.webUrl" alt=""  @click="showimg(fyindex)"></van-swipe-item>
                        <template #indicator>
                        <!-- <div class="custom-indicator">{{ list[fyindex].currimg }}/{{list[fyindex].picture.length}}</div> -->
                        </template>
                    </van-swipe>
                    <div class="fyxx">
                        <span>公示名称：{{ item.publicName}}</span>
                        <!-- <span>积分：{{ item.nowScore}}</span> -->
                        <span>所属小区：{{ item.villageName}}</span>
                        <span>收入所属时间开始：{{item.incomeStart}}</span>
                        <span>收入所属时间结束：{{ item.incomeEnd}}</span>
                    </div>
                </div>
			</van-list>
            </div>
        </div>
        <div style="height:20px;width:100%"></div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
    data() {
        return {
            pageNum:0,
            loading: false,//列表加载的
            finished: false,//列表加载的
            refreshing: false,//列表加载的
            refreshing:false,
            ss:'',
            list:[],
            total:'',
            starttime:'',
            endtime:''
        }
    },
    mounted() {
        
    },
    methods: {
        chongzhi(){
            this.starttime = ''
            this.endtime = ''
            this.ss = ''
            this.list = []
            this.pageNum = 0
            this.onLoad()
        },
        search(){
            this.list = []
            this.pageNum = 0
            this.onLoad()
        },
        showimg(index){
            var that = this
            ImagePreview({
                images: that.list[index].attachs.map(item=>{
                    return item.webUrl
                }),
                closeable: true,
            });
        },
        getdata(dateStart,dateEnd,ss){
            this.$axios.get('/api/v1/wygl/incomepublic/list', {
                params: {
                    pageNum:this.pageNum,
                    pageSize:10,
                    houseId:sessionStorage.getItem('houseId'),
                    dateStart:dateStart,
                    dateEnd:dateEnd,
                    keyword:ss,
                }
            }).then(res => {
                res.data.map(item=>{
                    item.incomeStart = item.incomeStart.substring(0,10)
                    item.incomeEnd = item.incomeEnd.substring(0,10)
                })
                this.total = res.total
                this.list.push(...res.data);
                this.pageNum++;
                this.loading = false;
            });
        },
        onLoad(){
            setTimeout(() => {
                if (this.refreshing) {
                    // 清空列表数据
                    this.pageNum = 1;
                    this.list = [];
                    this.refreshing = false;
                }
                this.getdata(this.starttime,this.endtime,this.ss)
                this.pageNum++;
                this.loading = false;
                if (this.list.length >= this.total) {
                    this.finished = true;
                }
            }, 500);
        }
    },
}
</script>
<style lang="less" scoped>
    .sfbz{
        .sfbzcontent{
            margin: 2% 5%;
        }
        .van-list{
            width: 100%;
        }
        .van-swipe-item{
            img{
            height: 100%;
            width: 100%;
            }
        }
        .searchall{
            width: 100%;
            padding: 10px;
            display: flex;
            flex-direction: column;
            input{
                outline: none;
                border: 1px solid #939393;
                border-radius: 5px;
                height: 30px;
            }
        }
        .btns{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
        .search{
            display: flex;
            align-items: center;
            font-size: 13px;
            text-align: center;
            span{
                width: 30%;
            }
        }
        .datesearch{
            input{
                width: 34%;
            }
        }
        .bz{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-radius: 10px;
            box-shadow: 0 0 10px #dadada;
            padding: 0 10px;
            box-sizing: border-box;
            .fyitem {
                margin-top: 10px;
                height: 100px;
                width: 100%;
                display: flex;
                .lb {
                    width: 35%;
                    height: 100%;
                }
                .fyxx {
                    margin-left: 2%;
                    font-size: 13px;
                    width: 60%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                }
            }
        }
    }
</style>